export const flags = {
  debug: localStorage.getItem("debug") === "true",
  debugPathing: localStorage.getItem("debug-pathing") === "true",
};
